import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["headerTitle", "status", "docNo", "sourceDocumentNo", "docDate", "onHandleClick", "isFromFinalInspector", "onMoreIconClick", "onSEPrintMoreClick", "isFromAppointment", "isFromInspection", "isFromEstimate", "isFromJobcard", "statusKey", "isFromServiceEstimate", "IsFromParentAPt", "parentComponent", "onClickJobCardStatusProgress", "IsRevisedEstimate", "isFromIspection", "isShowMoreIcon"];
import { Chip, Grid, IconButton, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ArrowLeftIcon, StepperOpenIcon } from "../../assets/images";
import { EParentModuleName, Module, StatusEnum, isModuleConfig } from "../../constants";
import { useAppSelector } from "../../store/hooks";
import { gray } from "../../theme/palette";
import { getStatusColor } from "../../theme/statusColors";
import useAnalyticsEventTracker from "../../utils/useAnalyticsEventTracker";
import { dateFormate } from "../../utils/utils";
import { MuiIconButton } from "./iconButtonComponent";
import SkeletonLoader from "./sketeton";
import { MuiStack } from "./stackComponent";
import { MoreVert } from "@mui/icons-material";
export default function HeaderDetails(props) {
    var headerTitle = props.headerTitle, status = props.status, docNo = props.docNo, sourceDocumentNo = props.sourceDocumentNo, docDate = props.docDate, onHandleClick = props.onHandleClick, _a = props.isFromFinalInspector, isFromFinalInspector = _a === void 0 ? false : _a, onMoreIconClick = props.onMoreIconClick, onSEPrintMoreClick = props.onSEPrintMoreClick, isFromAppointment = props.isFromAppointment, isFromInspection = props.isFromInspection, isFromEstimate = props.isFromEstimate, isFromJobcard = props.isFromJobcard, statusKey = props.statusKey, isFromServiceEstimate = props.isFromServiceEstimate, IsFromParentAPt = props.IsFromParentAPt, parentComponent = props.parentComponent, onClickJobCardStatusProgress = props.onClickJobCardStatusProgress, IsRevisedEstimate = props.IsRevisedEstimate, isFromIspection = props.isFromIspection, _b = props.isShowMoreIcon, isShowMoreIcon = _b === void 0 ? true : _b, others = _objectWithoutProperties(props, _excluded);
    var _c = useState(true), isShowSkeleton = _c[0], setShowSkeleton = _c[1];
    var RevisedEstimate = useParams().RevisedEstimate;
    var isServiceTypeChanged = useAppSelector(function (state) { return state === null || state === void 0 ? void 0 : state.crud; }).isServiceTypeChanged;
    var trackButtonClick = useAnalyticsEventTracker('HeaderDetails');
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down('sm'); });
    useEffect(function () {
        if (docNo || docDate) {
            setShowSkeleton(false);
        }
    }, [docNo, docDate]);
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        gap: '16px',
        sx: {
            paddingTop: {
                xs: '9px',
                sm: '9px',
                md: '20px',
                lg: '20px'
            },
            paddingX: {
                xs: '16px',
                sm: '16px',
                md: '24px',
                lg: '24px'
            }
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center",
        sx: {
            gap: {
                xs: '8px',
                sm: '8px',
                md: '16px',
                lg: '16px'
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        sx: {
            padding: 0
        },
        onClick: function () {
            onHandleClick();
            trackButtonClick("ButtonClickEvent", "".concat(parentComponent) + "_Back_Click", undefined);
        },
        id: "backMenu"
    }, /*#__PURE__*/ React.createElement("img", {
        src: ArrowLeftIcon,
        alt: "back"
    })), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1"
    }, headerTitle))), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, !isFromFinalInspector && !props.IsFromParentAPt && !isFromIspection && statusKey && /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Chip, _extends({
        id: "CardStatus",
        label: status || '-'
    }, getStatusColor(status || ''), {
        size: "small",
        sx: {
            padding: '2px 8px',
            borderRadius: '6px'
        }
    })), parentComponent == EParentModuleName.Jobcard && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiIconButton, {
        sx: {
            padding: 0
        },
        onClick: function () {
            onClickJobCardStatusProgress();
            trackButtonClick("ButtonClickEvent", "".concat(parentComponent) + "_Stepper_Click", undefined);
        }
    }, /*#__PURE__*/ React.createElement("img", {
        id: "StepperOpenIcon",
        height: '24px',
        width: '24px',
        src: StepperOpenIcon
    })))))), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between',
        alignItems: "center",
        sx: {
            paddingLeft: {
                md: '36px',
                lg: '36px'
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        gap: '24px',
        width: "100%",
        sx: {
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, parentComponent == EParentModuleName.Appointment && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: gray
    }, t("APT. NO"), "."), parentComponent == EParentModuleName.Inspection && !props.IsFromParentAPt && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: gray
    }, t("VI. NO")), parentComponent == EParentModuleName.ServiceEstimate && !isFromIspection && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: gray
    }, t("EST. NO"), "."), parentComponent == EParentModuleName.Jobcard && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: gray
    }, t("JC. NO"), "."), !isShowSkeleton && !isFromIspection && /*#__PURE__*/ React.createElement(Typography, {
        id: "docNumber",
        fontWeight: 'normal',
        style: {
            wordBreak: "break-all",
            textWrap: "pretty"
        }
    }, parentComponent == EParentModuleName.Inspection ? /*#__PURE__*/ React.createElement(React.Fragment, null, docNo) : /*#__PURE__*/ React.createElement(React.Fragment, null, Module === isModuleConfig.Bajaj ? sourceDocumentNo ? "".concat(sourceDocumentNo) : "" : "".concat(docNo).concat(sourceDocumentNo ? " / ".concat(sourceDocumentNo) : ""))), isShowSkeleton && !props.IsFromParentAPt && /*#__PURE__*/ React.createElement("span", {
        "flex-direction": 'column',
        style: {
            width: '150px',
            height: '4vh',
            padding: "1.5px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        width: isMobile ? "33%" : "30%"
    }, parentComponent == EParentModuleName.Appointment && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: gray
    }, t("APT. DATE")), parentComponent == EParentModuleName.Inspection && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: gray
    }, !props.IsFromParentAPt ? t("VI. DATE") : ""), parentComponent == EParentModuleName.ServiceEstimate && !isFromIspection && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: gray,
        minWidth: "112px"
    }, t("EST. CREATED DATE")), parentComponent == EParentModuleName.Jobcard && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: gray
    }, t("JC. DATE")), isShowSkeleton && !props.IsFromParentAPt && /*#__PURE__*/ React.createElement("span", {
        "flex-direction": 'column',
        style: {
            width: '150px',
            height: '4vh',
            padding: "1.5px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'normal',
        id: "docDate"
    }, !isShowSkeleton && !isFromIspection && docDate && dateFormate(docDate)))), (parentComponent == EParentModuleName.Appointment || parentComponent == EParentModuleName.ServiceEstimate || parentComponent == EParentModuleName.Jobcard || parentComponent == EParentModuleName.Inspection && (statusKey == StatusEnum.Completed || statusKey == StatusEnum.Open || statusKey == StatusEnum.Converted)) && statusKey && (parentComponent == EParentModuleName.Appointment && (statusKey == StatusEnum.Cancelled || statusKey == StatusEnum.Closed || statusKey == StatusEnum.Error || statusKey == StatusEnum.Awaiting || statusKey == StatusEnum.Inward) || parentComponent == EParentModuleName.Jobcard && (statusKey == StatusEnum.Awaiting || statusKey === StatusEnum.Cancelled) || parentComponent == EParentModuleName.ServiceEstimate && (statusKey == StatusEnum.Error || statusKey == StatusEnum.Awaiting || statusKey == StatusEnum.Cancelled || statusKey == StatusEnum.Closed || statusKey == StatusEnum.Converted) || (IsRevisedEstimate || RevisedEstimate) && statusKey == StatusEnum.Approved ? onSEPrintMoreClick && /*#__PURE__*/ React.createElement(IconButton, {
        id: "more-actions",
        onClick: onSEPrintMoreClick,
        size: "small",
        sx: {}
    }, /*#__PURE__*/ React.createElement(MoreVert, {
        color: "secondary"
    })) : isShowMoreIcon ? /*#__PURE__*/ React.createElement(IconButton, {
        id: "more-actions",
        onClick: onMoreIconClick,
        size: "small",
        sx: {}
    }, /*#__PURE__*/ React.createElement(MoreVert, {
        color: "secondary"
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null))));
}
